import { SET_LOADING_DATA } from "./types";

export function setLoadingData(Data) {
    return {
        type: SET_LOADING_DATA,
        Data,
    };
};